// Action key prefix for order integrations
export const ORDER_INTEGRATION_ACTION_PREFIX = 'order/integration/';
